import { useState } from 'react';

import { Outlet, useSearchParams } from 'react-router-dom';

import { PAYMENT_SUCCESSFUL_PARAM } from '@/shared/constants/routes/searchParams';
import { useExecuteOneTime } from '@/shared/hooks/useExecuteOneTime';
import { Loader } from '@/shared/ui/Loader';

export const PaymentDelayLayout = () => {
  const [searchParams] = useSearchParams();

  const [isDelayAfterPayment, setIsDelayAfterPayment] = useState(true);

  useExecuteOneTime(() => {
    const hasPaymentSuccessfulParam = searchParams.has(PAYMENT_SUCCESSFUL_PARAM);

    if (hasPaymentSuccessfulParam) {
      setTimeout(() => {
        setIsDelayAfterPayment(false);
      }, 2000);
    } else {
      setIsDelayAfterPayment(false);
    }
  });

  if (isDelayAfterPayment) {
    return <Loader />;
  }

  return <Outlet />;
};
